import { Store } from '@ngrx/store';
import { FeatureToggleService } from './../services/feature-toggle.service';
import { STEP, UserStateService } from './../services/userstate.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SignupCompleteGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly userStateService: UserStateService,
    private readonly featureToggleService: FeatureToggleService,
    private readonly store: Store
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return combineLatest([this.userStateService.hasDoneStep$(STEP.READY), this.userStateService.getNextStep$()]).pipe(
      map(([done, nextStep]) => {
        if (!done && nextStep === STEP.FRAUD_CHECK) {
          this.router.navigate(['/Register/Contact-Support']);
          return false;
        }

        if (!done && nextStep !== STEP.COMPLETE_PAYMENT && nextStep !== STEP.READY && nextStep !== STEP.WAITING_FOR_SEPA && nextStep !== STEP.AWAITING_ACTIVATION) {
          this.router.navigate(['/Register']);
          return false;
        }

        return true;
      })
    );
  }
}
